import React from 'react';
import NewProductTour from './NewProductTour';
const ProductTourComponent = () => <NewProductTour />;
export default ProductTourComponent;
